// Persist deferred-finalize intent across reload (idb-keyval).
// stop() при недоставленных чанках кладёт recordingId сюда; после reload
// useChunkUploadQueue восстанавливает Set и снова вызывает maybeAutoFinalize.
//
// Важно: отдельная БД, не общая с pending-chunks. idb-keyval createStore
// создаёт только один object store при первом open — два store в одной DB
// без bump version ломают transaction ("object store was not found").

import { createStore, del, get, set } from "idb-keyval";

const store = createStore("studyhub-recording-pending-finalize", "pending-finalize");
const KEY = "recording-ids";

export async function loadPendingFinalizeIds(): Promise<string[]> {
	try {
		const ids = await get<string[]>(KEY, store);
		return Array.isArray(ids) ? ids.filter((id) => typeof id === "string") : [];
	} catch {
		return [];
	}
}

export async function addPendingFinalizeId(recordingId: string): Promise<void> {
	try {
		const ids = await loadPendingFinalizeIds();
		if (ids.includes(recordingId)) return;
		await set(KEY, [...ids, recordingId], store);
	} catch {
		// IDB недоступен — in-memory pendingFinalizeRef всё ещё работает в сессии
	}
}

export async function removePendingFinalizeId(recordingId: string): Promise<void> {
	try {
		const ids = await loadPendingFinalizeIds();
		const next = ids.filter((id) => id !== recordingId);
		if (next.length === 0) await del(KEY, store);
		else await set(KEY, next, store);
	} catch {
		// ignore
	}
}
